import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Dialog, Paper } from '@mui/material';
import { closeAllModals, closeModal } from 'reducers/modalReducer';
import EmbeddedIFrame from 'views/Frames/EmbeddedIFrame';
import { ClmPortalIncomingPostMessageTypes } from 'utils/postMessageUtil';
import { useRuntimeConfig } from 'config/useRuntimeConfig';
import PageTitleToken from 'components/Common/PageTitleToken';

const KycAttestationModal = ({ brUid }: { brUid: string }) => {
  const dispatch = useDispatch();
  const runtimeConfig = useRuntimeConfig();

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    async function handleMessage(event: MessageEvent) {
      const message = event.data.message;
      if (message === ClmPortalIncomingPostMessageTypes.CLOSE_MODAL) {
        dispatch(closeModal('KycAttestationModal'));
      }
    }

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <Dialog
      id="kyc-attestation-modal"
      data-testid="kyc-attestation-modal"
      open={true}
      fullWidth={true}
      maxWidth="md"
      aria-labelledby="dialog-title"
      onClose={() => dispatch(closeAllModals())}
      PaperProps={{ style: { height: '70%' } }}
      PaperComponent={Paper}
    >
      <PageTitleToken />
      <EmbeddedIFrame
        id="kyc-attestation-iframe"
        title="KYC"
        url={`${runtimeConfig.configData.iframeUrls.brPurposeIframe}/br-purpose/br/${brUid}/attestation`}
        centered
        height="100%"
      />
    </Dialog>
  );
};

export default KycAttestationModal;
